/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сведения о сертификате
 */
export interface Certificate {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer: string;
}

/**
 * Запрос на проверку подписи при визировании
 */
export interface CheckViseSignatureRequest {
  /** Сведения о сертификате */
  certificate: Certificate;

  /** Документ для визирования */
  document: ViseDocument;

  /**
   * Подпись которую необходимо проверить
   * @example SGkgdGhlcmU=
   */
  signature: string;
}

/**
 * Документ для визирования
 */
export interface ViseDocument {
  /**
   * Тип документа (латиницей)
   * @example RU_PAYMENT_FOR_CONTROL
   */
  type: string;

  /**
   * Идентификатор документа
   * @example 255e8cca-657d-4e67-b977-e0804439ab63
   */
  id: string;
}

export interface CheckViseSignatureResponse {
  /** Результат валидности проверенной подписи. true - подпись валидна */
  valid: boolean;

  /**
   * Дата проверки подписи
   * @format date-time
   */
  date?: string;

  /** Комментарий */
  desc?: string;
}

/**
 * Ошибка
 */
export interface ErrorInfo {
  /** Код ошибки */
  errorCode?: "OK" | "ERROR" | "ERROR_DETAILS";

  /** Описание ошибки */
  errorDesc?: string;
}

export interface ErrorResponse {
  /** Список ошибок */
  errorList?: ErrorInfo[];
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  name?: string;
  description?: string;

  /** @format date-time */
  timestamp?: string;
}

export interface ChangeStatusRequest {
  payments: Payment[];
}

export interface Payment {
  /**
   * Идентификатор документа
   * @format uuid
   */
  paymentId: string;

  /** Статусы контролируемых платежей */
  status: "REJECT_CONTROL" | "CONTROLLED" | "TO_BE_CONTROLLED" | "EXPIRED";
}

export interface ChangeStatusResponse {
  payments?: Payment[];
}

/**
 * Информация о импортированном файле
 */
export interface ImportFileInfo {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Статус записи */
  status?:
    | "CREATED"
    | "LOADED"
    | "SIGNED"
    | "IN_PROGRESS"
    | "PROCESSED"
    | "PARTIALLY_PROCESSED"
    | "ERROR";

  /** Имя файла */
  filename?: string;

  /**
   * Количество записей в файле
   * @format int32
   */
  totalLineCount?: number;

  /** Хэш файла */
  hash?: string;

  /** Описание ошибки */
  errorDesc?: string;

  /**
   * Дата создания записи
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата время последней смены статуса
   * @format date-time
   */
  statusDate?: string;

  /** Признак того, что доступен файл с ошибками для скачивания */
  hasErrorFile?: boolean;
}

/**
 * Документ
 */
export interface SimpleDocumentDto {
  /** Тип документа (латиницей) */
  type: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  id: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface SimpleCcbResponse {
  ccb?: string;
  ccbFormat?: string;
  ccbVersion?: string;
}

export type All = ControlledPaymentReportRequest;

/**
 * Данные запроса получения отчёта
 */
export interface ControlledPaymentReportRequest {
  /** Формат отчёта */
  format?: "CSV" | "XLSX";

  /** Тип валюты отчёта */
  currencyType?: "RUB" | "USD" | "EUR";

  /** Тип запроса отчёта */
  requestType?: "SELECT_IDS" | "ALL";
}

/**
 * Список выбранных платежей
 */
export interface PaymentSelect {
  /**
   * Идентификатор платежа
   * @format uuid
   */
  id: string;

  /** Тип платежа */
  type: string;
}

export type SelectIds = ControlledPaymentReportRequest & {
  payments?: PaymentSelect[];
};

/**
 * Схема подписи клиента
 */
export interface SignScheme {
  /** Список ролей подписи */
  signScheme: SignSchemeItem[];
}

/**
 * Список ролей подписи
 */
export interface SignSchemeItem {
  /** Название роли подписи */
  role?: string;

  /**
   * Требуемое количество подписей
   * @format int32
   */
  count?: number;
}

/**
 * История платежного документа
 */
export interface PaymentHistoryDto {
  /** Список действий в истории платежного документа */
  historyList?: PaymentHistoryItem[];
}

/**
 * Действие над платежным документом
 */
export interface PaymentHistoryItem {
  /** Действие, совершённое над платежным документом */
  executedAction?: string;

  /**
   * Дата и время (в миллисекундах) совершения действия над платежным документом
   * @format int64
   */
  executedDate?: number;

  /** Сотрудник, выполнивший действие над платежным документом */
  executor?: string;
}

export interface BranchInfo {
  branchCode?: string;
  branchName?: string;
}

export interface BranchesInfo {
  branches?: BranchInfo[];
  hasMore?: boolean;
}

/**
 * Информация о счёте участника холдинга
 */
export interface Account {
  /**
   * Идентификатор счёта
   * @format uuid
   */
  id?: string;

  /** Номер счёта */
  number?: string;

  /** Валюта */
  currency?: string;

  /** Тип счёта */
  type?: string;

  /** Баланс счёта */
  balance?: string;
}

export interface HoldingAccountInfo {
  /**
   * Идентификатор организации
   * @format uuid
   */
  id?: string;

  /** Наименование организации */
  name?: string;

  /** ИНН организации */
  inn?: string;

  /** Информация о счёте участника холдинга */
  holdingAccount?: Account;

  /** Код филиала */
  branchCode?: string;

  /** Наименование филиала */
  branchName?: string;
}

export interface PagedResultHoldingAccountInfo {
  content?: HoldingAccountInfo[];

  /** @format int32 */
  totalRecord?: number;
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id: string;

  /** Внешний идентификатор документа */
  fileId: string;

  /** Имя файла */
  fileName: string;

  /** Готовность файла */
  ready: boolean;

  /** Код ошибки */
  errorCode?: string;

  /** Текст ошибки */
  errorDescription?: string;

  /**
   * Размер
   * @format int64
   */
  size?: number;
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface CurrControlOperation {
  /** Лимит операции */
  contractLimit?: boolean;

  /** Контрагенты */
  contractors?: CurrControlOperationContractor[];

  /**
   * Идентификатор договора/контракта
   * @format uuid
   */
  contractId?: string;

  /** Номер договора/контракта  */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер контракта/кредитного договора  */
  contractUnk?: string;

  /** Сумма по коду вида операции */
  paySum?: number;

  /**
   * Код валюты
   * @example USD
   */
  payCurrency?: string;

  /**
   * Код валютной операции
   * @example 21200
   */
  kvo?: string;

  /**
   * Код валюты договора
   * @example USD
   */
  contractCurrency?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата
   * @format date
   */
  refundDate?: string;
}

export interface CurrControlOperationContractor {
  name?: string;
  countryNumCode?: string;
}

/**
 * Досупные операции для документа
 */
export interface DocumentPermission {
  /** Имя операции */
  name: string;

  /** Описание операции */
  desc: string;

  /** Доступность операции */
  isAvailable?: boolean;
}

/**
 * Информация о связи
 */
export interface Link {
  /**
   * Идентификатор объекта, создателя связи
   * @format uuid
   */
  ownerId?: string;

  /** Тип объекта, создателя связи */
  ownerType?: string;

  /** Идентификатор связанного объекта */
  referenceId?: string;

  /** Тип связанного объекта */
  referenceType?: string;
}

/**
 * Информация о банке
 */
export interface PaymentBank {
  /**
   * Идентификатор банка
   * @format uuid
   */
  id?: string;

  /**
   * Наименование банка
   * @example Россельхозбанк
   */
  name: string;

  /** Тип населенного пункта */
  placetype: string;

  /** Наименование населенного пункта */
  placename: string;

  /**
   * БИК банка
   * @example 044030910
   */
  bic: string;

  /**
   * Кор. счет банка
   * @example 30101810900000000910
   */
  corAccount?: string;
  adress?: string;

  /** @format int64 */
  countryId?: number;
  latAdress?: string;
  latName?: string;
  isResident?: boolean;
  swift?: string;
}

/**
 * Полная информация о документе
 */
export interface PaymentDetailInfo {
  /**
   * Идентификатор платёжного документа
   * @format uuid
   * @example d97a3ae7-b32a-4677-825b-58cfb1e67ed9
   */
  id: string;

  /**
   * Идентификатор записи во внешней системе
   * @format uuid
   */
  extId?: string;

  /**
   * Сумма операции
   * @example 1500
   */
  amount: number;

  /**
   * Код вида документа:     PAYMENT_ORDER   - ПП     PAYMENT_DEMAND  - ПТ     PAYMENT_INCASSO - ИП
   * @example PAYMENT_ORDER
   */
  kind: string;

  /**
   * Способ отправки:     EMPTY           - ПустоURGENT - СрочноELECTRONICALLY - ЭлектронноMAIL - ПочтойTELEGRAPH - Телеграфом
   * @example EMPTY
   */
  sendType: "EMPTY" | "URGENT" | "ELECTRONICALLY" | "MAIL" | "TELEGRAPH";

  /**
   * Очерёдность
   * @format int32
   * @example 0
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   * @example Пример платежа партнёру, без НДС
   */
  ground: string;

  /**
   * Признак налогового платежа
   * @example false
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   * @example Пример
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   * @example 5312
   */
  kbk?: string;

  /**
   * Код ОКТМО
   * @example 312312
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   * @example 83123182739
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):1 - без акцепта2 - с акцептом
   * @format int32
   * @example 1
   */
  conditionPayment?: 1 | 2;

  /**
   * Срок акцепта (только для ПТ):1,2,3,4,5
   * @format int32
   * @example 2
   */
  acceptancePeriod?: 1 | 2 | 3 | 4 | 5;

  /**
   * Основание налогового платежа
   * @example Пример
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   * @example ПРИМЕР
   */
  taxPeriod?: string;

  /**
   * Номер налогового документа
   * @example 153
   */
  taxDocNumber?: string;

  /**
   * Дата налогового документа
   * @example 0
   */
  taxDocDate?: string;

  /**
   * Код выплат
   * @example 381092
   */
  payType?: string;

  /**
   * Код вида дохода
   * @example 7912
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   * @example 1321
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   * @example 02010
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платёжного документа
   * @example 412
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуг ЖКХ (ЖКУ)
   * @example 213
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   * @example 312
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС
   * @example 51235
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   * @example 312331
   */
  communalServicesAccNum?: string;

  /** Период оплаты */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   * @example 1234567890
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   * @example 123456789
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   * @example ООО Морской бриз
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   * @example 171211, г. Тверь, ул.Паши Савельевой, д.38
   */
  taxPayerAddress?: string;

  /**
   * Дата платёжного документа
   * @format date
   * @example 2022-08-30
   */
  date: string;

  /**
   * Дата отправки в банк
   * @format date-time
   */
  acceptedDate?: string;

  /**
   * Номер документа
   * @example 101
   */
  number: string;

  /**
   * Номер документа
   * @example 101
   */
  documentNumber: string;

  /**
   * Буквенный ISO-код валюты
   * @example RUB
   */
  currency: string;

  /**
   * Буквенный код статуса документа
   * @example NEW
   */
  state: string;

  /**
   * Комментарий банка при отказе обработки в анитифрод или АБС
   * @example NEW
   */
  bankComment?: string;

  /**
   * Комментарий банка
   * @example Отказ по причине не корректного номера КПП получателя
   */
  noteBank?: string;

  /**
   * Ссылка на идентификатор заявления на отзыв документа
   * @format uuid
   * @example 518efa52-ad68-11ed-afa1-0242ac120002
   */
  revokeId?: string;

  /** Доступные операции */
  permissions?: DocumentPermission[];

  /** Операции валютного контроля */
  currControlOperations?: CurrControlOperation[];

  /** Связи с другими документами */
  links?: Link[];

  /** Список вложений */
  attachments?: Attachment[];

  /** Признак включения документа в кредитный реестр */
  inCreditRegistry?: boolean;

  /** Статус документа РЦК */
  acceptationStatus?: string;

  /** Объединенный статус платежа */
  mergedStatus?: string;
  blockedForMassSignature?: boolean;
}

/**
 * Участник платежа
 */
export interface PaymentMember {
  /**
   * Идентификатор субъекта
   * @format uuid
   * @example c4b55aca-41b8-4708-9a36-dfc3090842d8
   */
  id: string;

  /**
   * Наименование субъекта
   * @example ООО Пример
   */
  name: string;

  /**
   * Номер счёта
   * @example 40702810935000001770
   */
  accountNumber: string;

  /**
   * ИНН
   * @example 7714698321
   */
  inn: string;

  /**
   * КПП
   * @example 771401001
   */
  kpp: string;

  /** Информация о банке */
  bank: PaymentBank;
}

/**
 * Данные банка на деталку бенефециара
 */
export interface BeneficiaryBankDetail {
  /** Наименование банка */
  name?: string;

  /** Адрес банка */
  address?: string;

  /** Город Банка */
  city?: string;

  /** Клиринговый код банка */
  clearingCode?: string;

  /** Swift */
  swift?: string;

  /**
   * Страна банка
   * @example GBR
   */
  countryCode?: string;

  /**
   * Наименование страны банка
   * @example UNITED KINGDOM
   */
  countryName?: string;
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface Operation {
  /** Идентификатор договора/контракта  */
  contractId?: string;

  /** Номер договора/контракта  */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер контракта/кредитного договора  */
  contractUnk?: string;

  /** Сумма по коду вида операции */
  paySum?: number;

  /**
   * Код валюты
   * @example USD
   */
  payCurrency?: string;

  /**
   * Код валютной операции
   * @example 21200
   */
  kvo?: string;

  /**
   * Код валюты договора
   * @example USD
   */
  contractCurrency?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата
   * @format date
   */
  refundDate?: string;

  /** Порядковый номер операции */
  number?: string;

  /** Тип операции */
  type?: string;

  /** Направление операции */
  direction?: string;

  /** Номер документа операции */
  documentNumber?: string;

  /**
   * Дата документа операции
   * @format date
   */
  documentDate?: string;

  /** Лимит операции */
  contractLimit?: boolean;

  /** Контрагенты договора */
  contractors?: OperationContractor[];
}

export interface OperationContractor {
  /** Имя контрагента */
  name?: string;
}

/**
 * Подробная информация о валютном платеже
 */
export interface PaymentOrderDetail {
  /**
   * Id документа
   * @format uuid
   */
  id: string;

  /**
   * Id внешнего документа
   * @format uuid
   */
  extId?: string;

  /** Статус документа РЦК */
  acceptationStatus?: string;

  /**
   * Код вида документа
   * @example FCY_PAYMENT_FOR_CONTROL
   */
  kind: string;

  /** Город */
  payerCity?: string;

  /** Международный адрес */
  payerAddress?: string;

  /**
   * Идентификатор плательщика
   * @format uuid
   */
  payerClientId?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Международное наименование */
  payerName?: string;

  /** Международные реквизиты изменены */
  internationalChanged?: boolean;

  /** Сумма операции  */
  sum?: number;

  /** Номер документа  */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа  */
  documentState?: string;

  /** Описание статуса документа  */
  documentStateDesc?: string;

  /** Тип клиента */
  clientType?: "BANK" | "UL";

  /** Имя плательщика */
  payerClientName?: string;

  /**
   * Дата создания платежного документа
   * @format date
   */
  sendDate?: string;

  /**
   * Идентификатор счета плательщика
   * @format uuid
   */
  accountId?: string;

  /** Номер счета плательщика  */
  accountNumber?: string;

  /** Валюта счета плательщика  */
  accountCurrency?: string;

  /** Описание платежа  */
  paymentDetails?: string;

  /** Код платежа:   OUR   SHA   BEN  */
  chargeType?: string;

  /**
   * Идентификатор счета комиссии плательщика
   * @format uuid
   */
  chargeAccountId?: string;

  /** Номер счета комиссии плательщика  */
  chargeAccountNumber?: string;

  /** Валюта счета комиссии плательщика  */
  chargeAccountCurrency?: string;

  /** Информация получателю */
  receiverInformation?: string;

  /** Тип валютного платежа: MT103/MT202 */
  swiftMessageType?: "MT103" | "MT202";

  /** Контактное лицо */
  contact?: string;

  /** Контактный номер телефона */
  contactPhone?: string;

  /** Отправлен в банк */
  isSent?: boolean;

  /** Список операций для валютного контроля */
  currencyControl?: Operation[];

  /** Список вложений */
  attachments?: Attachment[];

  /** Список полномочий */
  permissions?: Permission[];

  /** Свифт код */
  payerBankSwift?: string;

  /** Номер счета плательщик */
  payerExternalAccountNumber?: string;

  /** Данные банка плательщика. Название */
  payerBankName?: string;

  /** Данные банка плательщика. Код страны */
  payerBankCountryCode?: string;

  /** Данные банка плательщика. Город */
  payerBankCity?: string;

  /** Данные банка плательщика. Счет */
  payerBankAccount?: string;

  /** Идентификатор платежа (поле 20) */
  senderReference?: string;

  /** 121е поле. Уникальный референс транзакции */
  uetr?: string;

  /**
   * Дата валютирования
   * @format date
   */
  valueDate?: string;

  /** Связи */
  links?: Link[];

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /** Признак входящего документа */
  incoming?: boolean;

  /**
   * ИД отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Перевод на свой счет */
  selfPayment?: boolean;

  /** Объединенный статус платежа */
  mergedStatus?: string;

  /**
   * Идентификатор бенефециара
   * @format uuid
   */
  beneficiarId?: string;

  /** Наименование бенефециара  */
  beneficiarName?: string;

  /** ИНН бенефециара */
  beneficiarInn?: string;

  /** Страна бенефециара  */
  beneficiarCountry?: string;

  /** Город бенефециара  */
  beneficiarCity?: string;

  /** Адрес бенефециара  */
  beneficiarAddress?: string;

  /** Swift бенефециара если это банк */
  beneficiarySwift?: string;

  /** Номер счета бенефециара  */
  beneficiarAccountNumber?: string;

  /** Номер счета бенефециара в банке-посреднике  */
  beneficiarAgentAccountNumber?: string;

  /** Данные банка на деталку бенефециара  */
  beneficiarBank?: BeneficiaryBankDetail;

  /** Данные банка на деталку бенефециара  */
  beneficiarAgentBank?: BeneficiaryBankDetail;

  /** Код валюты:   USD - Доллар   EUR - Евро  */
  currency?: string;

  /**
   * Дата создания платежного документа
   * @format date-time
   */
  createDate?: string;

  /** Гарантированный платеж */
  chargeIsGrantType?: boolean;
}

/**
 * Полномочие
 */
export interface Permission {
  /** Название действия */
  name: string;

  /** Признак доступности действия */
  isAvailable: boolean;

  /** Описание действия */
  desc: string;
}

/**
 * Детальная информация о РПТС
 */
export interface TransitAccountOrderDetails {
  /**
   * Id документа
   * @format uuid
   */
  id: string;

  /**
   * Id внешнего документа
   * @format uuid
   */
  extId?: string;

  /** Статус документа РЦК */
  acceptationStatus?: string;

  /**
   * Код вида документа
   * @example TRANSIT_ACCOUNT_PAYMENT_FOR_CONTROL
   */
  kind: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Статус документа */
  state?: string;

  /** Описание статуса документа */
  stateDesc?: string;

  /**
   * Дата создания платежного документа
   * @format date
   */
  sendDate?: string;

  /** Номер счета для Перевода валюты в наш банк */
  currencyAccountNumber?: string;

  /**
   * Id счета для Перевода валюты в наш банк
   * @format uuid
   */
  currencyAccountId?: string;

  /**
   * Id счета для Продажи валюты в наш банк
   * @format uuid
   */
  rubleAccountId?: string;

  /** Номер счета для Продажи валюты в наш банк */
  rubleAccountNumber?: string;

  /** Счет для Продажи валюты в внешний банк */
  accountNumberExtBank?: string;

  /**
   * Id зачисления
   * @format uuid
   */
  noticeEnrollmentId?: string;

  /**
   * Дата зачисления
   * @format date
   */
  notificationDate?: string;

  /** Номер зачисления */
  notificationNumber?: string;

  /** Сумма зачисления */
  allSum?: number;

  /** Наименование внешнего Банка для продажи */
  bankSaleName?: string;

  /** БИК внешнего Банка для продажи */
  bankSaleBIC?: string;

  /** Номер счета внешнего Банка для продажи */
  bankSaleCorrAccount?: string;
  bankInfoComment?: string;
  bankInfoEmployee?: string;
  bankInfoEmployeeName?: string;

  /** @format date */
  bankInfoProcessDate?: string;

  /** @format date */
  bankInfoReceiveDate?: string;
  bankInfoRejectReason?: string;

  /**
   * Id транзитного счета
   * @format uuid
   */
  transitAccountId?: string;

  /** Валюта транзитного счета */
  transitAccountCurrency?: string;

  /** Номер транзитного счета */
  transitAccountNumber?: string;

  /**
   * Id ответственного
   * @format uuid
   */
  responsibleId?: string;

  /** ФИО ответственного */
  responsibleFullName?: string;

  /** Номер телефона ответственного */
  responsiblePhoneNumber?: string;

  /**
   * Id клиента
   * @format uuid
   */
  client?: string;
  clientINN?: string;
  clientName?: string;
  clientOGRN?: string;
  clientOKPO?: string;
  clientPhoneNumber?: string;

  /** Выбранный кпп клиента */
  clientKpp?: string;

  /** Сумма продажи */
  sumSale?: number;

  /** Валюта продажи */
  sumSaleCurr?: string;

  /** Сумма перевода */
  sumTransfer?: number;

  /** Валюта перевода */
  sumTransferCurr?: string;

  /** Суммы в разбивке по КВО */
  sums?: TransitAccountSum[];

  /** Вложения */
  attachments?: Attachment[];

  /** Информация для валютного контроля */
  currencyControl?: Operation[];

  /** Полномочия */
  permissions?: Permission[];

  /** Отправлен в банк */
  isSent?: boolean;

  /** Связи */
  links?: Link[];

  /** Признак наличия досыла */
  hasFileSending?: boolean;

  /**
   * ИД отзыва
   * @format uuid
   */
  revokeId?: string;

  /** Объединенный статус платежа */
  mergedStatus?: string;
}

/**
 * Информация о сумме по КВО
 */
export interface TransitAccountSum {
  /** Код вида операции */
  kvo?: string;

  /** Тип продажи */
  saleType?: string;

  /** Сумма по коду вида операции */
  sum?: number;
}

export interface ControlledAccountInfo {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Тип счёта */
  type?: string;

  /** Номер счёта */
  number?: string;

  /** Валюта счёта */
  currency?: string;

  /** Баланс счёта */
  currentBalance?: number;

  /** Наименование компании */
  name?: string;

  /** ИНН */
  inn?: string;

  /** Код филиала */
  branchCode?: string;

  /** Наименование филиала */
  branchName?: string;
}

export interface PagedResultControlledAccountInfo {
  content?: ControlledAccountInfo[];

  /** @format int32 */
  totalRecord?: number;
}

/**
 * Информация о импортированном файле
 */
export interface ImportFileDetailInfo {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Статус записи */
  status?:
    | "CREATED"
    | "LOADED"
    | "SIGNED"
    | "IN_PROGRESS"
    | "PROCESSED"
    | "PARTIALLY_PROCESSED"
    | "ERROR";

  /** Имя файла */
  filename?: string;

  /**
   * Количество записей в файле
   * @format int32
   */
  totalLineCount?: number;

  /** Хэш файла */
  hash?: string;

  /**
   * Дата создания записи
   * @format date-time
   */
  createDate?: string;

  /** Описание ошибки */
  errorDesc?: string;
  signers?: SignInfo[];

  /** Флаг того, что файл подписан */
  signed?: boolean;

  /** Признак того, что доступен файл с ошибками для скачивания */
  hasErrorFile?: boolean;
}

export interface SignInfo {
  /** Имя пользователя */
  username?: string;

  /**
   * Дата подписи
   * @format date-time
   */
  date?: string;

  /** Роль подписи */
  signRole?: string;

  /** Подпись */
  signature?: string;

  /** s/n сертификат */
  sn?: string;
}

export interface PagedResultImportFileInfo {
  content?: ImportFileInfo[];

  /** @format int32 */
  totalRecord?: number;
}

export interface ConfirmTypeResponse {
  confirmType?: string;
}

export interface PayerInfo {
  /**
   * Идентификатор
   * @format uuid
   */
  id?: string;

  /** Наименование */
  name?: string;
}

export interface PagedResultPaymentInfo {
  content?: PaymentInfo[];

  /** @format int32 */
  totalRecord?: number;
}

/**
 * Информация о платеже
 */
export interface PaymentInfo {
  /** @format uuid */
  documentId?: string;
  type?: string;

  /**
   * Дата документа
   * @format date
   */
  date?: string;

  /** Статус документа */
  status?: string;

  /** Детали операции */
  purposeOperation?: string;

  /** Валюта операции */
  currency?: string;

  /** тип операции */
  operationType?: string;

  /** Номер документа */
  docNumber?: string;

  /** Наименование визируемого ЮЛ */
  nameSender?: string;

  /** ИНН визируемого ЮЛ */
  innSender?: string;

  /** Счёт визируемого ЮЛ */
  accountSender?: string;

  /** Наименование получателя платежа */
  nameReceiver?: string;

  /** ИНН получателя платежа */
  innReceiver?: string;

  /** Счёт получателя платежа */
  accountReceiver?: string;

  /** Банк получателя платежа */
  bankReceiver?: string;

  /**
   * Дата-время установки РЦК статуса платежа
   * @format date-time
   */
  acceptationCreated?: string;

  /** Статусы контролируемых платежей */
  acceptationStatus?:
    | "REJECT_CONTROL"
    | "CONTROLLED"
    | "TO_BE_CONTROLLED"
    | "EXPIRED";

  /** ФИО сотрудника */
  acceptationName?: string;

  /** сумма продажи (всегда на рублевый счет) */
  saleAmount?: number;

  /** валюта продажи */
  saleCurrency?: string;
  revenueAccount?: string;

  /** сумма перевода */
  transferAmount?: number;

  /** валюта перевода */
  transferCurrency?: string;

  /** номер уведомления */
  notificationNumber?: string;

  /**
   * дата уведомления
   * @format date
   */
  notificationDate?: string;

  /** сумма поступления */
  receiptAmount?: number;

  /** валют поступления */
  receiptAmountCurrency?: string;

  /** Сумма операции */
  amount?: number;

  /** Объединенный статус платежа */
  mergedStatus?: string;
}

export interface GetCheckingBranchesParams {
  code: "HLD" | "RCK";
}

export interface FindHoldingAccountParams {
  /** Фильтр по наименованию компании */
  searchName?: string;

  /** Фильтр по ИНН */
  searchInn?: string;

  /** Фильтр по номеру счёта */
  searchHoldingAccountNumber?: string;

  /** Массив с кодами филиалов */
  searchBranchCode?: string[];

  /**
   * Сортировка по полям
   * @format field,asc|desc
   */
  sort?: string;

  /** Номер страницы. */
  page?: string;

  /** Размер страницы */
  size?: string;
}

export interface FindControlledAccountParams {
  /** Поиск по имени, ИНН и номеру счёта */
  searchControlled?: string;

  /** Массив для передачи кодов филиала */
  searchBranchCode?: string[];

  /**
   * Сортировка по полям
   * @format field,asc|desc
   */
  sort?: string;

  /** Номер страницы. */
  page?: string;

  /** Размер страницы */
  size?: string;
}

export interface FindControlledFilesParams {
  /** Номер страницы. */
  page?: string;

  /** Размер страницы */
  size?: string;
}

export interface FindControlledPayersParams {
  /** Список статусов */
  statusList?: string[];

  /** Текст поиска по плательщику */
  payerSearchText?: string;

  /** Текст поиска по получателю */
  receiverSearchText?: string;

  /** Текст поиска по сумме */
  amountSearchText?: string;

  /** Текст поиска по сумме от */
  amountFrom?: string;

  /** Текст поиска по сумме до */
  amountTo?: string;

  /** Дата с */
  beginDate?: string;

  /** Дата по */
  endDate?: string;

  /** Список идентификаторов плательщиков */
  payerIds?: string[];

  /** Текст поиска по номеру счета плательщика  (мин 3) */
  payerSearchAccount?: string;

  /** Текст поиска по номеру ИНН плательщика  (мин 3) */
  payerSearchInn?: string;

  /** Текст поиска по имени получателя  (мин 3) */
  receiverSearchName?: string;

  /** Текст поиска по счету получателя  (мин 3) */
  receiverSearchAccount?: string;

  /** Текст поиска по ИНН получателя  (мин 3) */
  receiverSearchInn?: string;

  /** Текст поиска по по номеру документа (мин 1) */
  documentNumber?: string;

  /** Текст поиска по назначению платежа (мин 3) */
  purposeOperationSearch?: string;

  /** Фильтр по типам документа */
  typeSearch?: string[];

  /** Статусы контролируемых платежей */
  acceptationStatus?:
    | "REJECT_CONTROL"
    | "CONTROLLED"
    | "TO_BE_CONTROLLED"
    | "EXPIRED";

  /** Дата акцепта с */
  acceptationDateFrom?: string;

  /** Дата акцепта по */
  acceptationDateTo?: string;

  /**
   * Сортировка по полям
   * @format field,asc|desc
   */
  sort?: string;

  /** Номер страницы. */
  page?: string;

  /** Размер страницы */
  size?: string;
}

export interface FindControlledPaymentParams {
  /** Список статусов */
  statusList?: string[];

  /** Текст поиска по плательщику */
  payerSearchText?: string;

  /** Текст поиска по получателю */
  receiverSearchText?: string;

  /** Текст поиска по сумме */
  amountSearchText?: string;

  /** Текст поиска по сумме от */
  amountFrom?: string;

  /** Текст поиска по сумме до */
  amountTo?: string;

  /** Дата с */
  beginDate?: string;

  /** Дата по */
  endDate?: string;

  /** Список идентификаторов плательщиков */
  payerIds?: string[];

  /** Текст поиска по номеру счета плательщика  (мин 3) */
  payerSearchAccount?: string;

  /** Текст поиска по номеру ИНН плательщика  (мин 3) */
  payerSearchInn?: string;

  /** Текст поиска по имени получателя  (мин 3) */
  receiverSearchName?: string;

  /** Текст поиска по счету получателя  (мин 3) */
  receiverSearchAccount?: string;

  /** Текст поиска по ИНН получателя  (мин 3) */
  receiverSearchInn?: string;

  /** Текст поиска по по номеру документа (мин 1) */
  documentNumber?: string;

  /** Текст поиска по назначению платежа (мин 3) */
  purposeOperationSearch?: string;

  /** Фильтр по типам документа */
  typeSearch?: string[];

  /** Статусы контролируемых платежей */
  acceptationStatus?:
    | "REJECT_CONTROL"
    | "CONTROLLED"
    | "TO_BE_CONTROLLED"
    | "EXPIRED";

  /** Дата акцепта с */
  acceptationDateFrom?: string;

  /** Дата акцепта по */
  acceptationDateTo?: string;

  /**
   * Сортировка по полям
   * @format field,asc|desc
   */
  sort?: string;

  /** Номер страницы. */
  page?: string;

  /** Размер страницы */
  size?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-rck
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-rck.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/browse/OB_CASHMAN-26 <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=245138349)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Метод проверки подписи документа при визировании Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags ConfirmationExternal
     * @name ViseCheckSignature
     * @summary Проверка подписи при визировании
     * @request POST:/api/rck/external/v1/signatures/vise/check
     * @secure
     */
    viseCheckSignature: (
      data: CheckViseSignatureRequest,
      params: RequestParams = {}
    ) =>
      this.request<CheckViseSignatureResponse, ErrorResponse | ErrorMessage>({
        path: `/api/rck/external/v1/signatures/vise/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод служит для передачи статуса платежа визирующим Required permission: **RU_PAYMENT_FOR_CONTROL_DECLINE_ACCEPT**
     *
     * @tags payment-external-resource-impl
     * @name ChangeStatus
     * @summary Запрос передачи статуса платежа визирующим
     * @request POST:/api/rck/external/v1/control/change/status
     * @secure
     */
    changeStatus: (data: ChangeStatusRequest, params: RequestParams = {}) =>
      this.request<ChangeStatusResponse, ErrorResponse>({
        path: `/api/rck/external/v1/control/change/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для загрузки статусов платежей Required permission: **RU_PAYMENTS_CONTROL_FILE_UPLOAD**
     *
     * @tags import-payment-external-resource-impl
     * @name UploadControlledFile
     * @summary Запрос для загрузки статусов платежей
     * @request POST:/api/rck/external/v1/control/change/file
     * @secure
     */
    uploadControlledFile: (data: { file: File }, params: RequestParams = {}) =>
      this.request<ImportFileInfo, ErrorResponse>({
        path: `/api/rck/external/v1/control/change/file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для получения контрольного криптоблока конкретного документа Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags ConfirmationExternal
     * @name BuildDocumentCcb
     * @summary Получение контрольного криптоблока конкретного документа
     * @request POST:/api/rck/external/v1/ccb/build
     * @secure
     */
    buildDocumentCcb: (data: SimpleDocumentDto, params: RequestParams = {}) =>
      this.request<SimpleCcbResponse, ErrorResponse | ErrorMessage>({
        path: `/api/rck/external/v1/ccb/build`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает сгенерированный файл Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags payment-external-resource-impl
     * @name GenerateWorkbookSync
     * @summary Метод генерации отчетов о визируемых платежах
     * @request POST:/api/rck/external/v1/accept/documents/report
     * @secure
     */
    generateWorkbookSync: (data: All | SelectIds, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/api/rck/external/v1/accept/documents/report`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Метод для получения схемы подписи для клиента Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags ConfirmationExternal
     * @name GetSignatureSchemesForClient
     * @summary Получение схемы подписи для клиента
     * @request GET:/api/rck/external/v1/signature-schemes/{clientId}
     * @secure
     */
    getSignatureSchemesForClient: (
      clientId: string,
      params: RequestParams = {}
    ) =>
      this.request<SignScheme, ErrorResponse | ErrorMessage>({
        path: `/api/rck/external/v1/signature-schemes/${clientId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description При визировании используется документ, созданный как копия визируемого с расширенными данными Required permission: **RU_PAYMENT_FOR_CONTROL_GET**
     *
     * @tags document-external-resource-impl
     * @name GetInternalDocumentForPrint
     * @summary Получение внутреннего документа в формате PDF для печати
     * @request GET:/api/rck/external/v1/payment/print/{paymentId}/{type}
     * @secure
     */
    getInternalDocumentForPrint: (
      paymentId: string,
      type: string,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorResponse>({
        path: `/api/rck/external/v1/payment/print/${paymentId}/${type}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description При визировании используется документ, созданный как копия визируемого с расширенными данными Required permission: **RU_PAYMENT_FOR_CONTROL_GET**
     *
     * @tags document-external-resource-impl
     * @name GetInternalDocumentHistory
     * @summary Получение истории изменения платежного документа
     * @request GET:/api/rck/external/v1/payment/history/{paymentId}
     * @secure
     */
    getInternalDocumentHistory: (
      paymentId: string,
      params: RequestParams = {}
    ) =>
      this.request<PaymentHistoryDto, ErrorMessage | ErrorResponse>({
        path: `/api/rck/external/v1/payment/history/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для отображения списка филиалов визируемых организаций Required permission: **RU_PAYMENT_FOR_CONTROL_LIST or HOLDING_MEMBER_ACCOUNT_BALANCE_VIEW**
     *
     * @tags member-client-resource-impl
     * @name GetCheckingBranches
     * @request GET:/api/rck/external/v1/memberclient/branchlist
     * @secure
     */
    getCheckingBranches: (
      query: GetCheckingBranchesParams,
      params: RequestParams = {}
    ) =>
      this.request<BranchesInfo, ErrorResponse>({
        path: `/api/rck/external/v1/memberclient/branchlist`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения счетов холдинга Required permission: **HOLDING_MEMBER_ACCOUNT_BALANCE_VIEW**
     *
     * @tags holding-account-external-resource-impl
     * @name FindHoldingAccount
     * @summary Запрос на получение счетов холдинга
     * @request GET:/api/rck/external/v1/holding-account/find
     * @secure
     */
    findHoldingAccount: (
      query: FindHoldingAccountParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultHoldingAccountInfo, ErrorResponse>({
        path: `/api/rck/external/v1/holding-account/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод служит для получения детальной информации о платеже Required permission: **RU_PAYMENT_FOR_CONTROL_GET**
     *
     * @tags payment-external-resource-impl
     * @name GetPaymentInfo
     * @summary Запрос на получение детальной информации о платеже
     * @request GET:/api/rck/external/v1/controlled-payment/details/{paymentId}/{docType}
     * @secure
     */
    getPaymentInfo: (
      paymentId: string,
      docType: string,
      params: RequestParams = {}
    ) =>
      this.request<
        | PaymentDetailInfo
        | PaymentOrderDetail
        | TransitAccountOrderDetails
        | (PaymentDetailInfo & PaymentOrderDetail & TransitAccountOrderDetails),
        ErrorResponse
      >({
        path: `/api/rck/external/v1/controlled-payment/details/${paymentId}/${docType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения визируемых счетов Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags controlled-account-external-resource-impl
     * @name FindControlledAccount
     * @summary Запрос на получение визируемых счетов
     * @request GET:/api/rck/external/v1/controlled-account/find
     * @secure
     */
    findControlledAccount: (
      query: FindControlledAccountParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultControlledAccountInfo, ErrorResponse>({
        path: `/api/rck/external/v1/controlled-account/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для получение подробной информации о загруженном файле Required permission: **RU_PAYMENTS_CONTROL_FILE_VIEW**
     *
     * @tags import-payment-external-resource-impl
     * @name FindById
     * @summary Запрос на получение подробной информации о загруженном файле
     * @request GET:/api/rck/external/v1/control/change/file/{id}
     * @secure
     */
    findById: (id: string, params: RequestParams = {}) =>
      this.request<ImportFileDetailInfo, ErrorResponse>({
        path: `/api/rck/external/v1/control/change/file/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для получение файла с ошибками по обработке Required permission: **RU_PAYMENTS_CONTROL_ERROR_DOWNLOAD**
     *
     * @tags import-payment-external-resource-impl
     * @name FindErrorLogById
     * @summary Запрос на получение файла с ошибками по обработке
     * @request GET:/api/rck/external/v1/control/change/file/{id}/error/log
     * @secure
     */
    findErrorLogById: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/api/rck/external/v1/control/change/file/${id}/error/log`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для загрузки статусов платежей Required permission: **RU_PAYMENTS_CONTROL_FILE_VIEW**
     *
     * @tags import-payment-external-resource-impl
     * @name FindControlledFiles
     * @summary Запрос для загрузки статусов платежей
     * @request GET:/api/rck/external/v1/control/change/file/find
     * @secure
     */
    findControlledFiles: (
      query: FindControlledFilesParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultImportFileInfo, ErrorResponse>({
        path: `/api/rck/external/v1/control/change/file/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для получения типа подтверждения Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags ConfirmationExternal
     * @name GetConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/rck/external/v1/confirm-type/{clientId}
     * @secure
     */
    getConfirmType: (clientId: string, params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorResponse | ErrorMessage>({
        path: `/api/rck/external/v1/confirm-type/${clientId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения плательщиков Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags payment-external-resource-impl
     * @name FindControlledPayers
     * @summary Запрос на получение плательщиков
     * @request GET:/api/rck/external/v1/accept/documents/payersnamelist
     * @secure
     */
    findControlledPayers: (
      query: FindControlledPayersParams,
      params: RequestParams = {}
    ) =>
      this.request<PayerInfo[], ErrorResponse>({
        path: `/api/rck/external/v1/accept/documents/payersnamelist`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения списка визируемых платежей Required permission: **RU_PAYMENT_FOR_CONTROL_LIST**
     *
     * @tags payment-external-resource-impl
     * @name FindControlledPayment
     * @summary Запрос на получение списка визируемых платежей
     * @request GET:/api/rck/external/v1/accept/documents/find
     * @secure
     */
    findControlledPayment: (
      query: FindControlledPaymentParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultPaymentInfo, ErrorResponse>({
        path: `/api/rck/external/v1/accept/documents/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
